import React from 'react';
import { TypographyH4 } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import InfoTooltip from '@/Components/Tooltip/InfoTooltip';

function InviteCandidateTooltipBody(): React.JSX.Element {
    return (
        <InfoTooltip
            side="right"
            size="icon-xs"
            description={
                <div className="flex max-w-sm flex-col gap-4">
                    <TypographyH4 className="text-foreground text-base leading-snug font-semibold">
                        {UIStrings.InviteCoWorkersAsInternalBenchmark}
                    </TypographyH4>
                    <div className="text-justify text-sm leading-relaxed">
                        <span className="text-foreground font-bold">{`${UIStrings.DidYouKnow} `}</span>
                        <span className="text-foreground">{`${UIStrings.InviteCoWorkersAsInternalBenchmarkExplanation1} `}</span>
                        <span className="text-foreground">{`${UIStrings.InviteCoWorkersAsInternalBenchmarkExplanation2} `}</span>
                    </div>
                </div>
            }
        />
    );
}

export default InviteCandidateTooltipBody;
